module.exports = __webpack_public_path__ + "static/img/10xindong.f4cd88e5.gif";